<template>
  <b-overlay :show="displayOverlay" rounded="sm">
    <o-card :title="title" :sync-page-title="syncPageTitle" :shadow="shadow" :bg-transparent="bgTransparent" v-if="!(hideIfEmpty && data.data.length == 0)">
      <slot name="filter"></slot>
      <div class="table-responsive" ref="tableMainDiv" :class="divClasses"
          :style="{'max-height': stickyHeader ? height + 'px' : '' }">
        <table class="table table-sm" :class="{'table-hover': fullRowClick && rowClickFunction}">
          <thead>
          <tr>
            <slot name="head"></slot>
            <slot name="head-controls">
              <th class="text-right" v-if="enableNew">
                <router-link :to="{ path: $route.path + '/new'}" class="btn btn-primary">
                  {{$t('core.new')}}
                </router-link>
                <router-link v-for="(button, index) in extraButton" :key="index"
                            :to="{ path: $route.path + '/' + button.slug }" class="btn btn-primary">
                  {{button.name}}
                </router-link>
              </th>
            </slot>
            <slot name="head-end"></slot>
          </tr>
          </thead>
          <tbody ref="tbody">
          <tr v-if="data.data.length == 0">
            <td :colspan="columnCount" class="text-center pt-4 pb-1">{{$t('core.no_data_found')}}</td>
          </tr>
          <router-link  v-for="(item, itemIndex) in data.data" :key="itemIndex" tag="tr"
                        :class="{'bg-primary text-white': fullRowClick && rowClickFunction && itemIndex.toString() === selectedRow.toString(),
                        'bg-light-yellow': highlightRow(item), 'bg-light-grey': greyRow(item), 'bg-light-red': redRow(item)}"
                        @click.native="fullRowClick && rowClickFunction ? rowClickForward(item, itemIndex) : null"
                        :to="fullRowClick && !rowClickFunction ? resolveEditRoute(item) : ''">
            <slot name="body" :item="item">
              no controls for body slot specified
            </slot>
            <slot name="body-controls" :item="item">
              <td class="text-right" v-if="enableDelete || enableEdit || enableView || extraRowButton || customRowButton">
                <div class="btn-group btn-group-sm" role="group" aria-label="edit controls">
                  <o-delete v-if="enableDelete" method="delete" :url="deleteUrl() + '/' + item.id"
                            v-on:action-executed="search"></o-delete>
                  <router-link v-if="enableView" :to="{ path: $route.path + '/view/' + item.id }" class="btn btn-primary">
                    <fa icon="eye"/>
                  </router-link>
                  <router-link v-if="enableEdit" :to="resolveEditRoute(item)" class="btn btn-primary">
                    <fa icon="pencil-alt"/>
                  </router-link>
                  <slot name="custom-row-button" v-if="extraRowButton || customRowButton" :item="item">
                    <router-link v-for="(button, index) in extraRowButton" :key="index"
                                :to="{ path: $route.path + '/' + item.id }" class="btn btn-primary">
                      <fa :icon="button.icon"/>
                    </router-link>
                  </slot>
                </div>
              </td>
            </slot>
          </router-link>
          </tbody>
          <tfoot>
          <slot name="foot"></slot>
          </tfoot>
        </table>
      </div>

      <template slot="footer">
        <template v-if="enablePageLength">
          <div class="row">
            <div class="col-md-1 mt-3" v-if="enablePageLength">
              <o-pagelength :enable-page-length="enablePageLength"  v-on:set-record-length="setRecordLength"></o-pagelength>
            </div>
            <div class="col-md-11">
              <o-pagination :data="data.meta.pagination" v-on:change-page="changePage"
                        class="mt-3"></o-pagination>
            </div>
          </div>
        </template>
        <template v-else>
          <o-pagination :data="data.meta.pagination" v-on:change-page="changePage"
          class="mt-3"></o-pagination>
        </template>
      </template>
    </o-card>
  </b-overlay>
</template>

<script>
  import axios from 'axios'
  import qs from 'qs'

  export default {
    name: 'o-table',

    props: {
      url: {
        type: String,
        required: true
      },
      title: {
        type: String,
        default: ''
      },
      syncPageTitle: {
        type: Boolean,
        default: true
      },
      enableNew: {
        type: Boolean,
        default: true
      },
      enableEdit: {
        type: Boolean,
        default: true
      },
      enableDelete: {
        type: Boolean,
        default: true
      },
      shadow: {
        type: Boolean,
        default: true
      },
      customDelete: {
        type: Boolean,
        default: false
      },
      enableView: {
        type: Boolean,
        default: false
      },
      extraButton: {
        type: Array,
        default: null
      },
      extraRowButton: {
        type: Array,
        default: null
      },
      customRowButton: {
        type: Boolean,
        default: false
      },
      // Optional function: (item) => { path: '/something' }. When provided, both the row click
      // and the edit button resolve via this function — used by the contract lists to route to
      // the dynamic detail page when the contract's sales line has has_dynamic_detail = true.
      editRoute: {
        type: Function,
        default: null
      },
      defaultSortBy: {
        type: String,
        default: 'id'
      },
      defaultSortByDirection: {
        type: String,
        default: 'asc'
      },
      fullRowClick: {
        type: Boolean,
        default: false
      },
      rowClickFunction: {
        type: Boolean,
        default: false
      },
      bgTransparent: {
        type: Boolean,
        default: false
      },
      stickyHeader: {
        type: Boolean,
        default: false
      },
      onlyFilterable: {
        type: Boolean,
        default: false
      },
      highlightRow: {
        type: Function,
        default: () => {
          return false
        }
      },
      greyRow: {
        type: Function,
        default: () => {
          return false
        }
      },
      hideIfEmpty: {
        type: Boolean,
        default: false
      },
      customDivClass: {
        type: String,
        default: null
      },
      showOverlay: {
        type: Boolean,
        default: false
      },
      redRow: {
        type: Function,
        default: () => {
          return false
        }
      },
      enablePageLength : {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      data: {
        data: [],
        meta: {
          pagination: {
            current_page: 1
          }
        },
        filters: [],
        sortBy: '',
        sortByDirection: ''
      },
      selectedRow: [-1],
      height: 0,
      loading: false,
      displayOverlay: false,
      basePerPage: 20
    }),

    computed: {
      columnCount() {
        return this.$slots.head.filter((item) => {
            return (item && item.componentOptions && item.componentOptions.tag === 'o-table-header')
          }).length
      },
      divClasses() {
        var classes = {'sticky-table': this.stickyHeader}
        if (this.customDivClass) {
          classes[this.customDivClass] = true
        }
        return classes
      }
    },

    methods: {
      resolveEditRoute(item) {
        if (typeof this.editRoute === 'function') {
          const custom = this.editRoute(item)
          if (custom) {
            return custom
          }
        }
        return { path: this.$route.path + '/' + item.id }
      },
      changePage(page) {
        this.data.meta.pagination.current_page = page
        this.search()
      },
      isIE() {
          var isIE11 = navigator.userAgent.indexOf(".NET CLR") > -1;
          var isIE11orLess = isIE11 || navigator.appVersion.indexOf("MSIE") != -1;
          return isIE11orLess;
      },
      async downloadExcel() {
        this.$root.$loading.start()

        await axios
          .get(this.url, {
            headers: {
              'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'blob',
            paramsSerializer: qs.stringify,
            params: {
              transformer: 'excel',
              page: this.data.meta.pagination.current_page,
              per_page: 999999,
              filter: this.filters,
              sortBy: this.sortBy,
              sortByDirection: this.sortByDirection
            }
          })
          .then((response) => {
            this.$root.$loading.finish()

            let name = 'export'

            if (!this.isIE()) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', name +'.xlsx');
                document.body.appendChild(link);
                link.click();
            }
            else {
                window.navigator.msSaveOrOpenBlob(new Blob([response.data]),  name +'.xlsx');
            }
          })
          .catch((error) => {
            this.$root.$loading.finish()
            console.log(error)
            window.alert('could not load data from ' + this.url)
          })
      },
      search() {
        this.loading = true
        this.$root.$loading.start()

        if(this.showOverlay) {
          this.displayOverlay = true
        }

        axios
          .get(this.url, {
            paramsSerializer: qs.stringify,
            params: {
              page: this.data.meta.pagination.current_page,
              filter: this.filters,
              sortBy: this.sortBy,
              sortByDirection: this.sortByDirection,
              per_page:this.basePerPage
            }
          })
          .then((response) => {
            this.data = response.data
            this.resetSelectedRow()
            this.$emit('change-page', this.data.meta.pagination.current_page)
            this.$emit('total', this.data.meta.pagination.total)

            if (this.stickyHeader) {
              this.setHeight()
              if (this.$refs.tableMainDiv) {
                this.$refs.tableMainDiv.scroll({ top: 0, behavior: 'smooth' })
              }
            }

            if(this.showOverlay) {
              this.displayOverlay = false
            }
            this.loading = false
            this.$root.$loading.finish()
            this.$emit('loaded', response.data)
          })
          .catch((error) => {
            this.loading = false
            this.$root.$loading.finish()
            console.log(error)
            window.alert('could not load data from ' + this.url)
          })
      },
      setFilters(filters) {
        var flatFilters = {}
        filters.forEach((item) => {
          flatFilters[item.column] = item.value
        })

        if(flatFilters !== this.filters) {
          this.data.meta.pagination.current_page = 1
        }

        this.filters = flatFilters
        this.search()
      },
      sortColumn (options) {
        this.sortBy = options.column
        this.sortByDirection = options.direction

        // let all table header components know what column we sort by, we need this to activate the correct indicator
        // and also clear the previous sorted column indicator
        this.$slots.head.forEach((item) => {
          if (item && item.componentOptions && item.componentOptions.tag === 'o-table-header') {
            item.componentInstance.setSortProperties(this.sortBy, this.sortByDirection)
          }
        })

        this.search()
      },
      deleteUrl() {
        let url = this.url;
        // Always strip query strings for DELETE operations
        let splitUrl = url.split("?");
        if(Array.isArray(splitUrl) && splitUrl.length && 0 in splitUrl) {
          return splitUrl[0];
        }
        return url
      },
      rowClickForward (item, index) {
        this.$emit('row-click', item)
        this.$set(this.selectedRow, 0, index)
      },
      resetSelectedRow () {
        this.$set(this.selectedRow, 0, -1)
      },
      setHeight () {
        const windowHeight = window.innerHeight
        const deductHeight = this.data.meta.pagination.total_pages <= 1 ? 176 : 246
        const height = (windowHeight - deductHeight).toFixed()
        this.height = parseInt(height)
      },
      setRecordLength(val) {
        this.basePerPage = val
        this.search()
      },
    },
    created () {
      this.sortBy = this.defaultSortBy
      this.sortByDirection = this.defaultSortByDirection
    },
    mounted() {
      this.basePerPage = this.enablePageLength ? this.perPage : 20
      this.$nextTick(() => {
        window.addEventListener('resize', this.setHeight)
      })

      if (!this.loading && !this.onlyFilterable) {
        this.search()
      }
      this.$on('sort-column', this.sortColumn)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.setHeight)
    }
  }

</script>

<style>
.bg-light-yellow {
  background-color: lightyellow;
}

.bg-light-grey {
  background-color: lightgrey;
}

.bg-light-red {
  background-color: #f8d7da;
}
</style>
